import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N } from 'ng-zorro-antd/i18n';
import { zh_CN } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';

import { en_US } from 'ng-zorro-antd/i18n';
import en from '@angular/common/locales/en';

import { NgZorroAntdModule } from './ng-zorro-antd.module';
import { NgxEchartsModule } from 'ngx-echarts'


import { MenuComponent } from './menu/menu.component';
import { MainPageComponent } from './main-page/main-page.component';
import { PpiKgComponent } from './ppi-kg/ppi-kg.component';
import { GraphVisualComponent } from './graph-visual/graph-visual.component';
import { GraphSearchComponent } from './graph-search/graph-search.component';
import { GraphSearchItemComponent } from './graph-search-item/graph-search-item.component';
import { ProteinSearchPageComponent } from './protein-search-page/protein-search-page.component';
import { ProteinSearchResultComponent } from './protein-search-result/protein-search-result.component';
import { ProteinDetailComponent } from './protein-detail/protein-detail.component';
import { ProteinDetailContentComponent } from './protein-detail-content/protein-detail-content.component';

import { String2arrayPipe } from './pipe/string2array.pipe';
import { Null2stringPipe } from './pipe/null2string.pipe';
import { ChangeProteinTabPipe } from './pipe/changeProteinTab.pipe'




registerLocaleData(zh);

@NgModule({
   declarations: [
      AppComponent,
      MenuComponent,
      MainPageComponent,
      PpiKgComponent,
      GraphVisualComponent,
      GraphSearchComponent,
      GraphSearchItemComponent,
      ProteinSearchPageComponent,
      ProteinSearchResultComponent,
      ProteinDetailComponent,
      ProteinDetailContentComponent,
      String2arrayPipe,
      Null2stringPipe,
      ChangeProteinTabPipe,
      
   ],
   imports: [
      BrowserModule,
      AppRoutingModule,
      FormsModule,
      ReactiveFormsModule,
      HttpClientModule,
      BrowserAnimationsModule,
      NgZorroAntdModule,
      NgxEchartsModule,
      RouterModule.forRoot(
         [
            {
               path: '',
               redirectTo: '/home',
               pathMatch: 'full'
            },
            {
               path: 'home',
               component: MainPageComponent
            },
            {
               path: 'ppi',
               component: PpiKgComponent
            },
            {
               path: 'protein_search',
               component: ProteinSearchPageComponent
            },
            {
               path: 'protein_search_result/:property/:searchValue/:page',
               component: ProteinSearchResultComponent
            },
            {
               path: 'protein_detail/:logic_id',
               component: ProteinDetailContentComponent
            }
         ]
      )
   ],
   providers: [
      { provide: NZ_I18N, useValue: en_US }
   ],
   bootstrap: [
      AppComponent
   ],
   schemas: [
      CUSTOM_ELEMENTS_SCHEMA
   ]
})





export class AppModule { }
